import axios from "axios";
import { JSON_CONTENT_FORM_CONFIG } from "../Config";
import { getJSONContentFormConfig } from "../Config";

export const listOrders = async (page = 1, perPage = 18, customerIds = []) => {
  let params = `page=${page}&per_page=${perPage}`;
  if (customerIds.length > 0)
    params += `&customer_ids=${JSON.stringify(customerIds)}`;
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/orders/get-orders/?${params}`,
      JSON_CONTENT_FORM_CONFIG
    );
    return res.data;
  } catch {
    return {
      success: false,
    };
  }
};

export const getOrderDetail = async (orderId) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/orders/detail/${orderId}/`,
      JSON_CONTENT_FORM_CONFIG
    );
    return res.data;
  } catch {
    return {
      success: false,
    };
  }
};

export const removeLine = async (orderId, lineId) => {
  try {
    const jsonConfig = getJSONContentFormConfig();
    const res = await axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}/orders/remove-line/${orderId}/${lineId}/`,
      jsonConfig
    );
    return res.data;
  } catch {
    return {
      success: false,
    };
  }
};

export const editLineQuantity = async (orderId, lineId, qty) => {
  const data = JSON.stringify({ qty });
  try {
    const jsonConfig = getJSONContentFormConfig();
    const res = await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/orders/edit-line-quantity/${orderId}/${lineId}/`,
      data,
      jsonConfig
    );
    return res.data;
  } catch {
    return {
      success: false,
    };
  }
};

export const editLineDiscount = async (orderId, lineId, discount) => {
  const data = JSON.stringify({ discount });
  try {
    const jsonConfig = getJSONContentFormConfig();
    const res = await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/orders/edit-line-discount/${orderId}/${lineId}/`,
      data,
      jsonConfig
    );
    return res.data;
  } catch {
    return {
      success: false,
    };
  }
};

/**
 * Set order fulfilling branch to an order.
 *
 * @param {number} orderId - order ID for which branch to be set.
 * @returns {Promise<object>} Resolves to the response data from the API.
 *                            On success, returns the generated invoice no
 *                            On failure (e.g., permission denied), returns:
 *                            `{ success: false, detail: "You do not have permission to view invoices." }`.
 */
export const setOrderFulfillingBranch = async (orderId, branchId) => {
  const data = JSON.stringify({ branch_id: branchId });
  try {
    const jsonConfig = getJSONContentFormConfig();
    const res = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/orders/set-branch/${orderId}/`,
      data,
      jsonConfig
    );
    return {
      success: true,
    };
  } catch (error) {
    if (error.response && error.response.data && error.response.data.detail) {
      return {
        success: false,
        detail: error.response.data.detail,
      };
    }
    return {
      success: false,
      detail: "An unexpected error occurred while setting the branch.",
    };
  }
};
